export const AGUARDANDO_AGENDAMENTO = 'AGUARDANDO_AGENDAMENTO';
export const AGUARDANDO_COMPARECIMENTO = 'AGUARDANDO_COMPARECIMENTO';
export const NAO_COMPARECEU_AGENDAMENTO = 'NAO_COMPARECEU_AGENDAMENTO';